import { $, findTarget, findParent } from '../utils/Utils';

const select = (() => {
  const config = {
    triggerCN: '.js-selectTrigger',
    triggers: [...$('.js-selectTrigger')],
    labelCN: 'js-selectLabel',
    parent: 'js-selectParent',
  };

  const getValue = ({ trigger, parent, disablePlaceholder = false }) => {
    const t = (parent) ? parent.querySelector(config.triggerCN) : trigger;
    const option = t.options[t.selectedIndex];

    // return option value if it exists
    return (!option.getAttribute('value') && disablePlaceholder) ? null : t.options[t.selectedIndex].value;
  };

  const getLabel = ({ trigger, parent }) => {
    const t = (parent) ? parent.querySelector(config.triggerCN) : trigger;

    return t.options[t.selectedIndex].dataset.label;
  };

  const updateLabel = (trigger) => {
    const thisLabel = findTarget({
      element: trigger,
      parent: config.parent,
      target: config.labelCN,
    });

    // Gives the ability to have a data-label to show non-formatted value in the select
    thisLabel.textContent = (getLabel({ trigger }) !== undefined)
      ? getLabel({ trigger })
      : getValue({ trigger });
  };

  const handleBlur = (container) => {
    container.classList.remove('-focus');
  };

  const handleFocus = (container) => {
    container.classList.add('-focus');
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      // find select container
      const container = findParent(trigger, config.parent);

      trigger.addEventListener('change', () => {
        updateLabel(trigger);
      });

      // manually add class
      trigger.addEventListener('focus', () => {
        handleFocus(container);
      });
      trigger.addEventListener('blur', () => {
        handleBlur(container);
      });
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  // outside functions
  const update = (element) => {
    updateLabel(element);
  };

  const reboot = (container) => {
    const ts = [...container.querySelectorAll(config.triggerCN)];
    ts.forEach((trigger) => {
      const s = trigger;
      const thisLabel = findTarget({ element: s, parent: config.parent, target: config.labelCN });
      // set select value to first option,
      // which is usually a disabled option used as label
      s.selectedIndex = 0;
      // use the first option value as select input label
      thisLabel.textContent = s.options[s.selectedIndex].textContent;
    });
  };

  return {
    init,
    update,
    reboot,
    getValue,
    getLabel,
  };
})();

select.init();

export default select;
